import { ReactElement } from 'react';

import { VisitQuery, VisitSetInPersonExaminationPerformedCommand } from '@dreryk/egabinet-visit-frontend-api';

import { ModalConfirmButton } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { draftPrescriptionsTranslationKeys } from '../../../../../../../translations';

type PatientInPersonExaminationRequiredModalConfirmButtonProps = {
   onSuccess: PromiseVoidFunction;
   onClose: VoidFunction;
   visitId: number;
};

export const PatientInPersonExaminationRequiredModalConfirmButton = (
   props: PatientInPersonExaminationRequiredModalConfirmButtonProps
): ReactElement => {
   const { executeAsync: setPatientExaminedInPerson } = useCqrsCommand<void, void>(() => {
      const command = new VisitSetInPersonExaminationPerformedCommand();
      command.inPersonExaminationPerformed = true;
      command.visitId = props.visitId;
      return command;
   });
   return (
      <ModalConfirmButton
         testId={'patientInPersonExaminationRequiredConfirm'}
         label={draftPrescriptionsTranslationKeys.inPersonExaminationConfirm}
         onClick={async () => {
            try {
               await setPatientExaminedInPerson();
               await props.onSuccess();
            } finally {
               props.onClose();
               refetchCqrsQuery(VisitQuery);
            }
         }}
         blockingOperation={draftPrescriptionsTranslationKeys.submittingPrescription}
      />
   );
};
